export default "__VITE_ASSET__sArUmmNr__"